// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared type icons — aligned with palette menus (faDatabase / faCube). */

.JvFsEWQWqhQ7Mwoq6REw {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 8px;
  line-height: 1;
}

.ydGaqOO1hiXKOwilMASs,
.zRISZE5fgZVpCYPfFQfZ,
.iKSkJZ6BpTd54nB01ToV,
.UGUKDSb64BmyKZOK_ddo,
.eMXnj4T_gr4YU8AIVB21 {
  background: var(--curio-surface-muted);
  color: var(--curio-text-primary);
}

/* The source glyph is tinted rather than neutral, because it is also the
   FALLBACK a source with no icon renders in the grid - where the neutral
   treatment would read as a missing image rather than a deliberate mark. */
.AmibwArWg_BElxQM0Jiy {
  background: var(--curio-kind-source-bg);
  color: var(--curio-kind-source-on-tint);
}

/* Tinted for the same reason: the model glyph is the avatar of every model
   card, in the browse grid and in the canvas drawer. */
.KkKUWv8nvSg3TjPbJZtr {
  background: var(--curio-kind-model-bg);
  color: var(--curio-kind-model-on-tint);
}

/* Tinted to match the scenario cards, whose strips all wear this kind's
   colour: the page header, the drawers and the details view name the kind in
   the colour its cards wear. */
.Ti7yA8bQzsBvhKjQrg3E {
  background: var(--curio-kind-scenario-bg);
  color: var(--curio-kind-scenario-on-tint);
}

.jBtihZJkKkNpFpu6Z1CS {
  width: 22px;
  height: 22px;
  font-size: 11px;
  border-radius: 6px;
}

.fwtcGSmmVRMZ2kifjeCS {
  width: 36px;
  height: 36px;
  font-size: 16px;
}

.kDPeNeDpZZ7ariyMWjqi {
  width: 48px;
  height: 48px;
  font-size: 22px;
  border-radius: 10px;
}

/* Colored card strip header (browse cards) */
.sJBOteKX7MdJRolQgYDa {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  min-width: 0;
}

.A76P1wu2n1AXkthUaysT {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.dvz5XNa4R4v4N6sv5Ncr {
  width: 18px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.22);
  color: #ffffff;
  font-size: 10px;
  flex-shrink: 0;
}

.rxhCnxY_ttaFzekkDrFx {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.92);
  flex-shrink: 0;
}

.apy7KbEOxs0yTYr7_qZk {
  width: 1px;
  height: 12px;
  background: rgba(255, 255, 255, 0.28);
  flex-shrink: 0;
}

.E4PETtncRnYGcSRe2Djw {
  display: inline-flex;
  align-items: center;
  min-width: 0;
}

/* Drawer / inline title row with kind icon */
.aLHeRPlKqJdU_oKMXabJ {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.BBFv9bTJWYMPyl1aEr0g {
  margin: 0;
  font-size: 13px;
  font-weight: 700;
  color: #1e1f23;
}

/* Compact list-row header (drawer cards, installed rows — palette row parity) */
.qi2ARmNC4LV_a0uKhoXs {
  display: flex;
  align-items: center;
  gap: 7px;
  min-width: 0;
}

.a6Cy9YE37XHDuHkFsE04 {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  font: inherit;
  text-align: left;
}

.a6Cy9YE37XHDuHkFsE04:hover .fjQqdt5JNGFywqFnssgX {
  box-shadow: 0 0 0 1px rgba(47, 48, 52, 0.12);
}

.fjQqdt5JNGFywqFnssgX {
  flex-shrink: 0;
  border-radius: 4px;
  padding: 2px 6px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.02em;
  line-height: 1.3;
}

.ah1kwTABmyFvC4orGudU {
  background: var(--curio-format-geojson-bg);
  color: var(--curio-format-geojson-on-tint);
}

.TfzVEYBvZDUakKTAwggI {
  background: var(--curio-format-csv-bg);
  color: var(--curio-format-csv-on-tint);
}

.JMnWXsuNOxp8hJbSXSt8 {
  background: var(--curio-format-json-bg);
  color: var(--curio-format-json-on-tint);
}

.Pr4OnpVwQfWDSEktpUNW {
  background: var(--curio-format-parquet-bg);
  color: var(--curio-format-parquet-on-tint);
}

.coMCpCrJOhTFeKqSkg8T {
  background: var(--curio-format-geotiff-bg);
  color: var(--curio-format-geotiff-on-tint);
}

.zPseaXPn6fgrZdxV0YK_ {
  background: var(--curio-format-shp-bg);
  color: var(--curio-format-shp-on-tint);
}

.SDw5cvyp2_fkC1Ot0quh {
  background: var(--curio-format-bundle-bg);
  color: var(--curio-format-bundle-on-tint);
}

.YaYL27_2naTpzkNlt0rw {
  background: var(--curio-format-osm-bg);
  color: var(--curio-format-osm-on-tint);
}

/* A source's PBF resource is OpenStreetMap data, the Data Catalog's \`osm\`. */
.VEFTRh4j6c2XQ_wAcRxl {
  background: var(--curio-format-osm-bg);
  color: var(--curio-format-osm-on-tint);
}

.jKm0MQoViYc2Yj2lp9MQ {
  background: var(--curio-format-gpkg-bg);
  color: var(--curio-format-gpkg-on-tint);
}

.kqbDtKa4Kqtj_t3CuLeS {
  background: var(--curio-format-gtfs-bg);
  color: var(--curio-format-gtfs-on-tint);
}

._5vVZn5BKTM3lN9O7vflo {
  background: var(--curio-format-onnx-bg);
  color: var(--curio-format-onnx-on-tint);
}

.dijkMb6oDp3URymj7qnx {
  background: var(--curio-format-netcdf-bg);
  color: var(--curio-format-netcdf-on-tint);
}

.FXFfGGauq8EsFVtJuxyY {
  background: var(--curio-format-collection-bg);
  color: var(--curio-format-collection-on-tint);
}

.Lea9X3VXAWnNH1Te00xQ {
  flex-shrink: 0;
  border-radius: 4px;
  padding: 2px 6px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.02em;
  background: var(--curio-surface-muted);
  color: var(--curio-text-primary);
  line-height: 1.3;
}

.tss30tYK4GNIxgXuNfHN {
  background: var(--curio-category-data-bg);
  color: var(--curio-category-data-on-tint);
}

.GuT0KxmFy20tML1X_gvg {
  background: var(--curio-category-computation-bg);
  color: var(--curio-category-computation-on-tint);
}

.WWHTCFt0_lN_3Hm1k2W7 {
  background: var(--curio-category-vis-bg);
  color: var(--curio-category-vis-on-tint);
}

.pENnULhkGk2131wc9uQZ {
  background: var(--curio-category-package-bg);
  color: var(--curio-category-package-on-tint);
}
`, "",{"version":3,"sources":["webpack://./src/components/catalog/CatalogKindVisuals.module.css"],"names":[],"mappings":"AAAA,0EAA0E;;AAE1E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;;;EAKE,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;;2EAE2E;AAC3E;EACE,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA;uDACuD;AACvD;EACE,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;;+BAE+B;AAC/B;EACE,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA;EACE,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA,6EAA6E;AAC7E;EACE,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA;EACE,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA;EACE,6CAA6C;EAC7C,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,sCAAsC;EACtC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA;EACE,gDAAgD;EAChD,gDAAgD;AAClD;;AAEA;EACE,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,4CAA4C;EAC5C,4CAA4C;AAC9C","sourcesContent":["/* Shared type icons — aligned with palette menus (faDatabase / faCube). */\n\n.kindIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  border-radius: 8px;\n  line-height: 1;\n}\n\n.kindIcon_dataset,\n.kindIcon_package,\n.kindIcon_dataflow,\n.kindIcon_agent,\n.kindIcon_skill {\n  background: var(--curio-surface-muted);\n  color: var(--curio-text-primary);\n}\n\n/* The source glyph is tinted rather than neutral, because it is also the\n   FALLBACK a source with no icon renders in the grid - where the neutral\n   treatment would read as a missing image rather than a deliberate mark. */\n.kindIcon_source {\n  background: var(--curio-kind-source-bg);\n  color: var(--curio-kind-source-on-tint);\n}\n\n/* Tinted for the same reason: the model glyph is the avatar of every model\n   card, in the browse grid and in the canvas drawer. */\n.kindIcon_model {\n  background: var(--curio-kind-model-bg);\n  color: var(--curio-kind-model-on-tint);\n}\n\n/* Tinted to match the scenario cards, whose strips all wear this kind's\n   colour: the page header, the drawers and the details view name the kind in\n   the colour its cards wear. */\n.kindIcon_scenario {\n  background: var(--curio-kind-scenario-bg);\n  color: var(--curio-kind-scenario-on-tint);\n}\n\n.size_sm {\n  width: 22px;\n  height: 22px;\n  font-size: 11px;\n  border-radius: 6px;\n}\n\n.size_md {\n  width: 36px;\n  height: 36px;\n  font-size: 16px;\n}\n\n.size_lg {\n  width: 48px;\n  height: 48px;\n  font-size: 22px;\n  border-radius: 10px;\n}\n\n/* Colored card strip header (browse cards) */\n.stripRoot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  width: 100%;\n  min-width: 0;\n}\n\n.stripLeading {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n}\n\n.stripTypeIcon {\n  width: 18px;\n  height: 18px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  background: rgba(255, 255, 255, 0.22);\n  color: #ffffff;\n  font-size: 10px;\n  flex-shrink: 0;\n}\n\n.stripKindLabel {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.92);\n  flex-shrink: 0;\n}\n\n.stripDivider {\n  width: 1px;\n  height: 12px;\n  background: rgba(255, 255, 255, 0.28);\n  flex-shrink: 0;\n}\n\n.stripBadgeSlot {\n  display: inline-flex;\n  align-items: center;\n  min-width: 0;\n}\n\n/* Drawer / inline title row with kind icon */\n.titleWithKind {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.drawerTitleText {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 700;\n  color: #1e1f23;\n}\n\n/* Compact list-row header (drawer cards, installed rows — palette row parity) */\n.rowHeader {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  min-width: 0;\n}\n\n.rowHeaderButton {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  font: inherit;\n  text-align: left;\n}\n\n.rowHeaderButton:hover .formatBadge {\n  box-shadow: 0 0 0 1px rgba(47, 48, 52, 0.12);\n}\n\n.formatBadge {\n  flex-shrink: 0;\n  border-radius: 4px;\n  padding: 2px 6px;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  line-height: 1.3;\n}\n\n.formatBadge_geojson {\n  background: var(--curio-format-geojson-bg);\n  color: var(--curio-format-geojson-on-tint);\n}\n\n.formatBadge_csv {\n  background: var(--curio-format-csv-bg);\n  color: var(--curio-format-csv-on-tint);\n}\n\n.formatBadge_json {\n  background: var(--curio-format-json-bg);\n  color: var(--curio-format-json-on-tint);\n}\n\n.formatBadge_parquet {\n  background: var(--curio-format-parquet-bg);\n  color: var(--curio-format-parquet-on-tint);\n}\n\n.formatBadge_geotiff {\n  background: var(--curio-format-geotiff-bg);\n  color: var(--curio-format-geotiff-on-tint);\n}\n\n.formatBadge_shp {\n  background: var(--curio-format-shp-bg);\n  color: var(--curio-format-shp-on-tint);\n}\n\n.formatBadge_bundle {\n  background: var(--curio-format-bundle-bg);\n  color: var(--curio-format-bundle-on-tint);\n}\n\n.formatBadge_osm {\n  background: var(--curio-format-osm-bg);\n  color: var(--curio-format-osm-on-tint);\n}\n\n/* A source's PBF resource is OpenStreetMap data, the Data Catalog's `osm`. */\n.formatBadge_pbf {\n  background: var(--curio-format-osm-bg);\n  color: var(--curio-format-osm-on-tint);\n}\n\n.formatBadge_gpkg {\n  background: var(--curio-format-gpkg-bg);\n  color: var(--curio-format-gpkg-on-tint);\n}\n\n.formatBadge_gtfs {\n  background: var(--curio-format-gtfs-bg);\n  color: var(--curio-format-gtfs-on-tint);\n}\n\n.formatBadge_onnx {\n  background: var(--curio-format-onnx-bg);\n  color: var(--curio-format-onnx-on-tint);\n}\n\n.formatBadge_netcdf {\n  background: var(--curio-format-netcdf-bg);\n  color: var(--curio-format-netcdf-on-tint);\n}\n\n.formatBadge_collection {\n  background: var(--curio-format-collection-bg);\n  color: var(--curio-format-collection-on-tint);\n}\n\n.categoryBadge {\n  flex-shrink: 0;\n  border-radius: 4px;\n  padding: 2px 6px;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  background: var(--curio-surface-muted);\n  color: var(--curio-text-primary);\n  line-height: 1.3;\n}\n\n.categoryBadge_data {\n  background: var(--curio-category-data-bg);\n  color: var(--curio-category-data-on-tint);\n}\n\n.categoryBadge_computation {\n  background: var(--curio-category-computation-bg);\n  color: var(--curio-category-computation-on-tint);\n}\n\n.categoryBadge_vis {\n  background: var(--curio-category-vis-bg);\n  color: var(--curio-category-vis-on-tint);\n}\n\n.categoryBadge_package {\n  background: var(--curio-category-package-bg);\n  color: var(--curio-category-package-on-tint);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"kindIcon": `JvFsEWQWqhQ7Mwoq6REw`,
	"kindIcon_dataset": `ydGaqOO1hiXKOwilMASs`,
	"kindIcon_package": `zRISZE5fgZVpCYPfFQfZ`,
	"kindIcon_dataflow": `iKSkJZ6BpTd54nB01ToV`,
	"kindIcon_agent": `UGUKDSb64BmyKZOK_ddo`,
	"kindIcon_skill": `eMXnj4T_gr4YU8AIVB21`,
	"kindIcon_source": `AmibwArWg_BElxQM0Jiy`,
	"kindIcon_model": `KkKUWv8nvSg3TjPbJZtr`,
	"kindIcon_scenario": `Ti7yA8bQzsBvhKjQrg3E`,
	"size_sm": `jBtihZJkKkNpFpu6Z1CS`,
	"size_md": `fwtcGSmmVRMZ2kifjeCS`,
	"size_lg": `kDPeNeDpZZ7ariyMWjqi`,
	"stripRoot": `sJBOteKX7MdJRolQgYDa`,
	"stripLeading": `A76P1wu2n1AXkthUaysT`,
	"stripTypeIcon": `dvz5XNa4R4v4N6sv5Ncr`,
	"stripKindLabel": `rxhCnxY_ttaFzekkDrFx`,
	"stripDivider": `apy7KbEOxs0yTYr7_qZk`,
	"stripBadgeSlot": `E4PETtncRnYGcSRe2Djw`,
	"titleWithKind": `aLHeRPlKqJdU_oKMXabJ`,
	"drawerTitleText": `BBFv9bTJWYMPyl1aEr0g`,
	"rowHeader": `qi2ARmNC4LV_a0uKhoXs`,
	"rowHeaderButton": `a6Cy9YE37XHDuHkFsE04`,
	"formatBadge": `fjQqdt5JNGFywqFnssgX`,
	"formatBadge_geojson": `ah1kwTABmyFvC4orGudU`,
	"formatBadge_csv": `TfzVEYBvZDUakKTAwggI`,
	"formatBadge_json": `JMnWXsuNOxp8hJbSXSt8`,
	"formatBadge_parquet": `Pr4OnpVwQfWDSEktpUNW`,
	"formatBadge_geotiff": `coMCpCrJOhTFeKqSkg8T`,
	"formatBadge_shp": `zPseaXPn6fgrZdxV0YK_`,
	"formatBadge_bundle": `SDw5cvyp2_fkC1Ot0quh`,
	"formatBadge_osm": `YaYL27_2naTpzkNlt0rw`,
	"formatBadge_pbf": `VEFTRh4j6c2XQ_wAcRxl`,
	"formatBadge_gpkg": `jKm0MQoViYc2Yj2lp9MQ`,
	"formatBadge_gtfs": `kqbDtKa4Kqtj_t3CuLeS`,
	"formatBadge_onnx": `_5vVZn5BKTM3lN9O7vflo`,
	"formatBadge_netcdf": `dijkMb6oDp3URymj7qnx`,
	"formatBadge_collection": `FXFfGGauq8EsFVtJuxyY`,
	"categoryBadge": `Lea9X3VXAWnNH1Te00xQ`,
	"categoryBadge_data": `tss30tYK4GNIxgXuNfHN`,
	"categoryBadge_computation": `GuT0KxmFy20tML1X_gvg`,
	"categoryBadge_vis": `WWHTCFt0_lN_3Hm1k2W7`,
	"categoryBadge_package": `pENnULhkGk2131wc9uQZ`
};
export default ___CSS_LOADER_EXPORT___;
